export default {
  ROLES: {
    ADMIN: 'admin',
    RECRUITER: 'recruiter',
    REPRESENTATIVE: 'representative',
    INVITE: 'invite',
    ACTION: 'action',
    STUDENT: 'student',
  }
}
